module.exports = __webpack_public_path__ + "static/media/react_2.f7efd50e.jpg";